module.exports = __webpack_public_path__ + "static/media/cloud-download.fd3a8e03.svg";